// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-12Iqi","icon_spinning":"icon_spinning-1trVe","spin":"spin-1fNCK","bg-highlight":"bg-highlight-1gB4Z"};